import { LARGEST_CONTAINER_REQUIRED_STATES } from '../data/state-rules-2025.ts';
import { STATE_FIELDS_YEAR } from './state-fields.ts';

export function largestContainerRequired(state: string, year: number): boolean {
  return year === STATE_FIELDS_YEAR && LARGEST_CONTAINER_REQUIRED_STATES.includes(state);
}

/** Also used on drafts: missing optional values are allowed, invalid supplied values are not. */
export function largestContainerIssue(amount: number | null, maximum: number | null, required: boolean): string | null {
  if (amount == null) return required ? 'Maximum amount in largest container is required.' : null;
  if (!Number.isFinite(amount) || amount <= 0) return 'Maximum amount in largest container must be greater than zero.';
  if (maximum != null && amount > Math.round(maximum))
    return 'Maximum amount in largest container cannot exceed the facility maximum amount rounded to whole pounds for export.';
  return null;
}
